import { sessionStorageKeyConstants } from '../../constants/session-storage-key-constants'
import { getHeaders } from '../axios/axios-helpers'
import HttpClient from '../axios/http-client'

/* Change first password during user signup */
export async function changeFirstPassword(request) {
  const accessToken = sessionStorage.getItem(sessionStorageKeyConstants.ACCESS_TOKEN)
  const headers = getHeaders(accessToken)
  const httpClient = new HttpClient(headers)
  const userInstance = httpClient.userInstance()
  return userInstance.put('/changeFirstPassword', request)
}
